import { render } from "./Edit.vue?vue&type=template&id=af9d7564&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=af9d7564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9d7564"],['__file',"src/views/WantLists/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af9d7564"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af9d7564', __exports__)) {
    api.reload('af9d7564', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=af9d7564&scoped=true", () => {
    api.rerender('af9d7564', render)
  })

}


export default __exports__